import { API_STATUS } from 'core-lib/constants/network';
import ip from 'icepick';

import { ReducerType } from '../types/reducer';
import { reviewInitState } from '../utils/constants';
import {
  RESET_WIDGET_DATA,
  SHOW_CARS_COMPARISON_POPUP,
  UPDATE_BANNERS,
  UPDATE_COMPARISON_SEGMENT,
  UPDATE_CARS_COMPARISON,
  UPDATE_CAR_JOURNEY_ACTIVE_STEP,
  UPDATE_CAR_JOURNEY_BRAND_LIST,
  UPDATE_CAR_JOURNEY_FILTERS,
  UPDATE_CAR_JOURNEY_FINAL_RESULT,
  UPDATE_CAR_JOURNEY_PARTIAL_RESULT,
  UPDATE_CITY_LIST,
  UPDATE_DATA_BY_WIDGETS,
  UPDATE_DEALER_CITY_LIST,
  UPDATE_DEALER_HOME_DATA,
  UPDATE_DEALER_OFFER_DATA,
  UPDATE_DEALER_SELECTED_BRAND,
  UPDATE_DEALER_SELECTED_CITY,
  UPDATE_DEALER_USER_ADDRESS,
  UPDATE_LISTING,
  UPDATE_MODEL_DETAILS,
  UPDATE_MODEL_REVIEW,
  UPDATE_PHONE_BOOK_DATA,
  UPDATE_REVIEW_DETAILS,
  UPDATE_SEARCH_DATA,
  UPDATE_SEARCH_RESULTS,
  UPDATE_SWIPE_GESTURE,
  UPDATE_TEST_DRIVE_DETAILS,
  UPDATE_WIDGETS,
  UPDATE_WIDGET_SELECTED_STATE,
} from './type';

const initialState: ReducerType = ip.freeze({
  widgets: {
    data: null,
    apiStatus: API_STATUS.default,
  },
  widgetsData: {},
  widgetSelectedChip: {},
  phoneBookData: {},
  carComparison: {
    showPopup: false,
    data: [],
  },
  updateComparisonSegment: {
    data: [],
    selectedOption: {},
    apiStatus: API_STATUS.default,
  },
  testDriveDetails: {
    data: null,
    apiStatus: API_STATUS.default,
  },
  cityList: {
    data: null,
    apiStatus: API_STATUS.default,
  },
  modelData: {
    data: null,
    apiStatus: API_STATUS.default,
    selectedVariant: null,
    carId: null,
    selectedCity: null,
    newCarsScore: null,
    testDriveScore: null,
    date: null,
  },
  listing: {
    data: null,
    apiStatus: API_STATUS.default,
    queryFilters: '',
  },
  search: {
    data: null,
    apiStatus: API_STATUS.default,
    searchQuery: '',
    searchResults: [],
  },
  reviewDetails: reviewInitState,
  modelReview: {},
  carJourney: {
    activeStep: null,
    selectedFilters: {},
    partialResults: {
      data: [],
      apiStatus: API_STATUS.default,
    },
    finalResult: {
      data: null,
      apiStatus: API_STATUS.default,
    },
    brandList: {
      apiStatus: API_STATUS.default,
      data: [],
    },
  },
  isSwipeDown: false,
  dealerMarketing: {
    homeData: {},
    offersData: {},
    currentAddress: null,
    selectedCity: null,
    selectedBrand: null,
    dealerCityList: {
      data: { popular: [], cities: [] },
      apiStatus: API_STATUS.default,
    },
  },
  bannersData: {
    apiStatus: API_STATUS.default,
    data: [],
  },
});

const newCarsReducerV2 = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_WIDGETS: {
      state = ip.setIn(state, ['widgets'], payload);
      return state;
    }
    case UPDATE_DATA_BY_WIDGETS: {
      const newPayload = {
        ...state.widgetsData,
        [payload?.selectedBodyType
          ? `${payload.filter}-${payload?.selectedBodyType}`
          : payload.filter]: payload.data,
      };
      state = ip.setIn(state, ['widgetsData'], newPayload);
      return state;
    }
    case RESET_WIDGET_DATA: {
      state = ip.setIn(state, ['widgetsData'], {});
      state = ip.setIn(state, ['phoneBookData'], {});
      return state;
    }
    case UPDATE_PHONE_BOOK_DATA: {
      const newPayload = {
        ...state.phoneBookData,
        [payload.filter]: payload.data,
      };
      state = ip.setIn(state, ['phoneBookData'], newPayload);
      return state;
    }
    case UPDATE_WIDGET_SELECTED_STATE: {
      const newPayload = {
        ...state.widgetSelectedChip,
        [payload.widget]: payload.data,
      };
      state = ip.setIn(state, ['widgetSelectedChip'], newPayload);
      return state;
    }
    case UPDATE_MODEL_DETAILS: {
      state = ip.setIn(state, ['modelData'], payload);
      return state;
    }
    case UPDATE_CARS_COMPARISON: {
      state = ip.setIn(state, ['carComparison', 'data'], payload);
      return state;
    }
    case UPDATE_COMPARISON_SEGMENT: {
      const updatedCategory = {
        ...state.updateComparisonSegment, 
        data: payload.data,
        apiStatus: payload.apiStatus,
        selectedOption: payload.selectedOption,
      };

      return ip.setIn(state, ['updateComparisonSegment'], updatedCategory);
    }
    case SHOW_CARS_COMPARISON_POPUP: {
      state = ip.setIn(
        state,
        ['carComparison', 'showPopup'],
        payload.showPopup
      );
      return state;
    }
    case UPDATE_CITY_LIST: {
      state = ip.setIn(state, ['cityList'], payload);
      return state;
    }
    case UPDATE_MODEL_DETAILS: {
      state = ip.setIn(state, ['modelData'], payload);
      return state;
    }
    case UPDATE_LISTING: {
      state = ip.setIn(state, ['listing'], payload);
      return state;
    }
    case UPDATE_SEARCH_DATA: {
      state = ip.setIn(state, ['search'], payload);
      return state;
    }
    case UPDATE_SEARCH_RESULTS: {
      state = ip.setIn(state, ['search'], {
        ...state.search,
        searchResults: payload.searchResults,
        apiStatus: payload.apiStatus,
        searchQuery: payload.searchQuery,
      });
    }
    case UPDATE_TEST_DRIVE_DETAILS: {
      state = ip.setIn(state, ['testDriveDetails'], payload);
      return state;
    }
    case UPDATE_REVIEW_DETAILS: {
      state = ip.setIn(state, ['reviewDetails'], payload);
      return state;
    }
    case UPDATE_MODEL_REVIEW: {
      state = ip.setIn(state, ['modelReview'], payload);
      return state;
    }

    case UPDATE_CAR_JOURNEY_FILTERS: {
      state = ip.setIn(state, ['carJourney', 'selectedFilters'], payload);
      return state;
    }
    case UPDATE_CAR_JOURNEY_ACTIVE_STEP: {
      state = ip.setIn(state, ['carJourney', 'activeStep'], payload);
      return state;
    }

    case UPDATE_CAR_JOURNEY_PARTIAL_RESULT: {
      state = ip.setIn(state, ['carJourney', 'partialResults'], payload);
      return state;
    }
    case UPDATE_CAR_JOURNEY_FINAL_RESULT: {
      state = ip.setIn(state, ['carJourney', 'finalResult'], payload);
      return state;
    }
    case UPDATE_CAR_JOURNEY_BRAND_LIST: {
      state = ip.setIn(state, ['carJourney', 'brandList'], payload);
      return state;
    }
    case UPDATE_SWIPE_GESTURE: {
      state = ip.setIn(state, ['isSwipeDown'], payload);
      return state;
    }
    case UPDATE_DEALER_HOME_DATA: {
      const newPayload = {
        ...state.dealerMarketing.homeData,
        [payload.filter]: payload.data,
      };
      state = ip.setIn(state, ['dealerMarketing', 'homeData'], newPayload);
      return state;
    }
    case UPDATE_DEALER_OFFER_DATA: {
      const newPayload = {
        ...state.dealerMarketing.offersData,
        [payload.filter]: payload.data,
      };
      state = ip.setIn(state, ['dealerMarketing', 'offersData'], newPayload);
      return state;
    }
    case UPDATE_DEALER_CITY_LIST: {
      state = ip.setIn(state, ['dealerMarketing', 'dealerCityList'], payload);
      return state;
    }
    case UPDATE_DEALER_USER_ADDRESS: {
      state = ip.setIn(state, ['dealerMarketing', 'currentAddress'], payload);
      return state;
    }
    case UPDATE_DEALER_SELECTED_BRAND: {
      state = ip.setIn(state, ['dealerMarketing', 'selectedBrand'], payload);
      return state;
    }
    case UPDATE_DEALER_SELECTED_CITY: {
      state = ip.setIn(state, ['dealerMarketing', 'selectedCity'], payload);
      return state;
    }

    case UPDATE_BANNERS: {
      state = ip.setIn(state, ['bannersData'], payload);
      return state;
    }

    default: {
      return state;
    }
  }
};

export default newCarsReducerV2;
